<div class="compare_checkbox product-list-checkbox-container">
    <input type="checkbox" (change)="addCompare(myObject,myObject.isCompare)" [(ngModel)]="myObject.isCompare"
        [disabled]="disablingCheckbox && !myObject.isCompare" class="add-compare-checkbox">
    <label>{{'common.compare_product_note_checkbox'|cxTranslate}}</label>
</div>